import React from 'react';
import PropTypes from 'prop-types';
import { currency } from 'App/config';
import Shapes from 'Shapes';
var CartFreeDeliveryInfo = function (props) {
    var currentDeliveryPrice = props.currentDeliveryPrice, freeDeliveryData = props.freeDeliveryData, _a = props.wrapperClassName, wrapperClassName = _a === void 0 ? '' : _a, _b = props.spanClassName, spanClassName = _b === void 0 ? '' : _b;
    if (!currentDeliveryPrice || !freeDeliveryData || !freeDeliveryData.value) {
        return null;
    }
    var missingText = "brakuje ".concat(freeDeliveryData.value, " ").concat(currency);
    return (React.createElement("div", { className: wrapperClassName || '' },
        "Darmowa dostawa: ",
        React.createElement("span", { className: spanClassName }, missingText)));
};
CartFreeDeliveryInfo.propTypes = {
    currentDeliveryPrice: PropTypes.number.isRequired,
    freeDeliveryData: Shapes.upsellingItemShape,
    spanClassName: PropTypes.string,
    wrapperClassName: PropTypes.string,
};
export default CartFreeDeliveryInfo;
